var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-black bg-opacity-60 flex items-center justify-center rounded-3xl"},[_c('div',{staticClass:"h-28 w-28 flex items-center justify-center rounded-full -mt-16",class:`bg-${_vm.$store.getters['layout/getLayoutTheme']}`},[_c('IconCheckmark',{staticClass:"h-16 w-16"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }